import React, {Fragment} from 'react';
import {Container, Paper} from '@mui/material';
import DataTable from './Grid';
import {styled} from '@mui/material/styles';


const StyledPaper = styled(Paper)(({theme})=>({
  padding: theme.spacing(2),
  display: 'flex',
  overflow: 'auto',
  flexDirection: 'column',
}));

export default function Publishers() {
  return (
    <Fragment>
      <Container maxWidth='100%'>
        <StyledPaper>
          <DataTable />
        </StyledPaper>
      </Container>
    </Fragment>
  );
}
